import { motion } from "framer-motion";
import { BRAND } from "@/lib/constants";
import { SectionHeader } from "@/components/Services";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2 relative"
          >
            <div className="absolute -inset-4 bg-[radial-gradient(closest-side,rgba(212,175,55,0.2),transparent)] blur-2xl" />
            <div className="relative rounded-3xl p-8 glass">
              <img src={BRAND.logo} alt="VR Marketing Hub" className="w-40 h-40 rounded-full mx-auto ring-1 ring-[#D4AF37]/40 shadow-[0_0_40px_rgba(212,175,55,0.25)] object-cover" />
              <div className="text-center mt-6">
                <div className="text-lg font-bold text-white">VR Marketing Hub</div>
                <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mt-1">Growth · Leads · Results</div>
                <p className="mt-4 text-sm text-white/60 leading-relaxed">Boutique AI-powered marketing house, engineered for Indian businesses.</p>
              </div>
            </div>
          </motion.div>

          <div className="lg:col-span-3">
            <SectionHeader eyebrow="About Us" title="A modern marketing house built for India's ambitious brands." desc="We combine strategy, AI workflows and creative craft to help Indian businesses turn attention into revenue. No jargon, no fluff — only measurable growth." />
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                { t: "Made in India, for India", d: "Every campaign, creative and funnel is engineered for the Indian buyer." },
                { t: "AI-first workflows", d: "We blend human creative direction with modern AI to move faster and smarter." },
                { t: "Founder-led service", d: "You get direct access — no account manager runaround." },
                { t: "Built to scale", d: "From ₹10,000/month to enterprise budgets — our systems scale with you." },
              ].map((b) => (
                <div key={b.t} className="rounded-xl p-5 bg-white/[0.03] border border-white/10">
                  <div className="text-white font-semibold">{b.t}</div>
                  <div className="text-sm text-white/60 mt-1.5 leading-relaxed">{b.d}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
